import { environnement } from "configs/environnement";
import api from "./api";
import {
  ISaveResourcePermission,
  IUpdateResourcePermission,
  IResourcePermissionResponse,
  ResourceType,
} from "models/church.types";

const BASE_URL = `${environnement.baseURL}/resource-permissions`;

export const ResourcePermissionService = {
  /**
   * GET /api/eglise/v1/resource-permissions/_search
   * Récupère la liste paginée de toutes les permissions de ressources
   */
  getAll: async (page: number, size: number) => {
    const response = await api.get<IResourcePermissionResponse[]>(
      `${BASE_URL}/_search`,
      {
        params: {
          page: page,
          size: size,
          sort: "id,desc",
          query: "",
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  /**
   * POST /api/eglise/v1/resource-permissions
   * Créer une nouvelle permission
   */
  create: async (
    permission: ISaveResourcePermission,
  ): Promise<IResourcePermissionResponse> => {
    const response = await api.post<IResourcePermissionResponse>(
      `${BASE_URL}`,
      permission,
    );
    return response.data;
  },

  /**
   * PUT /api/eglise/v1/resource-permissions
   * Modifier une permission existante
   */
  update: async (
    permission: IUpdateResourcePermission,
  ): Promise<IResourcePermissionResponse> => {
    const response = await api.put<IResourcePermissionResponse>(
      `${BASE_URL}`,
      permission,
    );
    return response.data;
  },

  /**
   * GET /api/eglise/v1/resource-permissions/{id}
   */
  getById: async (id: number): Promise<IResourcePermissionResponse> => {
    const response = await api.get<IResourcePermissionResponse>(
      `${BASE_URL}/${id}`,
    );
    return response.data;
  },

  /**
   * DELETE /api/eglise/v1/resource-permissions/{id}
   */
  delete: async (id: number): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`);
  },

  /**
   * GET /api/eglise/v1/resource-permissions/_search
   * Recherche multicritère
   */
  search: async (query: string, page: number, size: number) => {
    const response = await api.get<IResourcePermissionResponse[]>(
      `${BASE_URL}/_search`,
      {
        params: {
          query: query,
          page: page,
          size: size,
          sort: "id,desc",
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  /**
   * Récupère la liste de lookup pour un type de ressource donné
   */
  getLookupResources: async (
    type: ResourceType,
  ): Promise<{ id: number; displayName: string }[]> => {
    const response = await api.get(`${BASE_URL}/lookup`, {
      params: { type },
    });
    return response.data;
  },
};
